module.exports = __webpack_public_path__ + "product-pure-powder-capsule-03.jpg?60f6fdf26a190126d65963b8ff5017fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-03.jpg
// module id = 85
// module chunks = 0